<template>
  <div v-if="currentEntretienCollectif">
    <div class="row">
      <div class="col-lg-6">
        <BreadCrumd
          :title="'Campagnes d\'entretien'"
          :description="'Aperçu d\'une fiche d\'entretien'"
        />
      </div>
      <div class="col-lg-6 mt-lg-4" v-if="currentEntretienCollectif">
        <Header :currentEntretienCollectif="currentEntretienCollectif" />
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="$router.push(sprov).catch(() => {})"
        >
          Liste des entretiens
        </button>

        <button
          v-if="
            currentEntretienCollectif.statut === CONST.BROUILLON ||
            currentEntretienCollectif.statut === CONST.PLANIFIER
          "
          type="button"
          class="btn btn-custom-primary"
          @click.prevent="editModal(currentEntretienCollectif.id)"
        >
          <i class="fa fa-edit font-size-17"></i> Modifier
        </button>
      </div>
      <div
        class="col-md-12 col-lg-6"
        v-if="currentEntretienCollectif.campagne.statut === CONST.C_CONFIRMER"
      >
        <ActionButton
          :currentEntretienCollectif="currentEntretienCollectif"
          @onUpdateStatut="init"
        />
      </div>
    </div>

    <div class="mt-4 mt-lg-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <b-nav tabs>
            <b-nav-item
              :to="{
                name: 'rh_entretien_collectif',
                params: { id: currentEntretienCollectif.id },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-eye text-custom-primary font-size-17"></i>
              Entretien</b-nav-item
            >

            <b-nav-item
              :to="{
                name: 'rh_entretien_collectif-document',
                params: {
                  id: currentEntretienCollectif.id,
                  documentUuid: currentEntretienCollectif.document.uuid,
                },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-paperclip text-custom-primary font-size-17"></i>
              Documents</b-nav-item
            >

            <b-nav-item
              :to="{
                name: 'rh_entretien_collectif_competence',
                params: { id: currentEntretienCollectif.id },
              }"
              exact
              exact-active-class="active"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Compétences</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'rh_entretien_collectif_objectif',
                params: { id: currentEntretienCollectif.id },
              }"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Objectifs de l'entretien</b-nav-item
            >
          </b-nav>
        </div>
      </div>

      <div>
        <router-view />
      </div>
    </div>
    <ModalEntretien
      ref="modalEntretien"
      :currentCampagne="currentEntretienCollectif.campagne"
      :statuts="entretienStatuts"
      @onRefresh="init"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import Header from '../components/Header.vue';
import ActionButton from '../components/ActionButton.vue';
import ModalEntretien from '../components/ModalEntretien.vue';
import CONST from '@/constants/rh/entretien';
export default {
  data() {
    return {
      CONST,
      sprov: this.$route.params.sprov,
    };
  },

  components: {
    Header,
    ActionButton,
    ModalEntretien,
  },
  computed: {
    ...mapGetters('entretien', [
      'currentEntretienCollectif',
      'entretienStatuts',
    ]),
  },

  methods: {
    ...mapActions('entretien', [
      'getEntretienCollectif',
      'setCurrentEntretienCollectif',
      'setEdit',
    ]),
    editModal(id) {
      this.$refs.modalEntretien.edit(id);
    },
    init() {
      this.setCurrentEntretienCollectif(null);
      this.setEdit(false);
      this.getEntretienCollectif({
        id: this.$route.params.entretienId,
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
